/**
 * 附件信息接口
 */
export interface FileInfo {
  /** 附件ID */
  id?: number | null;
  /** 文件ID */
  fileId?: string | null;
  /** 上传文件信息 */
  uploadFile?: UploadFileDto;
  /** 文件扩展名 */
  extensionType?: string | null;
  /** 附件类型 */
  type?: string | null;
  /** 上传人 */
  uploader?: string | null;
  /** 上传时间 */
  uploadTime?: string | null;
}

export interface Attachment {
  /** 文件ID */
  fileId: string | null;
  reportIncluded: boolean;
}

/**
 * 上传文件信息接口
 */
export interface UploadFileDto {
  /** 原始文件名 */
  extensionType?: string
  name?: string | null;
  /** OSS key */
  ossKey?: string | null;
}

export enum EDataOperationPermission {
  READ = 'READ', // 只读
  WRITE = 'WRITE', // 
  EXECUTE = 'EXECUTE', // 可填报
}